import { useState } from "react";

const useHandleSelection = (initialData = [], singleSelection) => {

  const [selectedKeys, setSelectedKeys] = useState(initialData);

  const handleSelection = (key) => {
    let auxSelectedKeys = [...selectedKeys];
    const keyAlreadySelected = auxSelectedKeys.includes(key);

    if (keyAlreadySelected) {
      auxSelectedKeys = auxSelectedKeys.filter((selectedKey) => selectedKey !== key);
    } else if (singleSelection) {
      auxSelectedKeys = [key];
    } else {
      auxSelectedKeys = [...auxSelectedKeys, key];
    }
    
    setSelectedKeys(auxSelectedKeys);
  }

  return {
    selectedKeys,
    handleSelection,
  };
}

export default useHandleSelection;
